import React from "react";

import { useUserData } from "src/store/AuthStore";
import { TokenRole } from "src/utils/decodeTokenScope";

export const formatTokenRole = ({
  name,
  arguments: args,
}: TokenRole): string => {
  const argList = Object.entries(args)
    .map(([key, value]) => `${key}=${value}`)
    .join(", ");
  return argList ? `${name} (${argList})` : name;
};

export const UserRolesDebugSection: React.FC = () => {
  const { roles } = useUserData();
  const formatted = (roles ?? []).map(formatTokenRole);

  return formatted.length > 0 ? (
    <div className="flex flex-wrap gap-2">
      {formatted.map((role) => (
        <span
          key={role}
          className="rounded border border-gray-200 px-2 py-1 font-code-12 text-gray-800"
        >
          {role}
        </span>
      ))}
    </div>
  ) : (
    <div className="font-inter-normal-12px text-gray-500">None</div>
  );
};
